import { loginModule } from "../../login-module";
import APP_VERSION from "../../../../appVersion";
import { idhaApiError } from "../../../utils/services/idhaApiErrorService";
import * as R from 'ramda'
import { managerApi } from "api/managerApi";

loginModule.controller('loginController', ['$scope', 'LoginService', 'SidebarService', 'LoadingBar', '$translate', 'dialogs', '$ngRedux', 'History', 'BackButton', 'UserIdha', 'localStorageService', '$location', '$stateParams','$window', function ($scope, LoginService, SidebarService, LoadingBar, $translate, dialogs, $ngRedux, History, BackButton, UserIdha, localStorageService, $location, $stateParams,$window) {

    var self = this;


    this.state = 'login';

    var params = $location.search();

    this.verified = params.verified;


    /**
     * The typed username
     */
    this.user = '';

    /**
     * The typed password
     */
    this.password = '';

    /*
     * Tells if at last one validation was fired
     */
    this.validated = false;
    this.loginType = null;

    /**
     * Fires the login proccess
     */
    this.doLogin = async function () {

        self.validated = true;

        if (!$scope.form.$invalid) {

            LoadingBar.show();

            self.loginFailed = false;

            try {
                let options:any = {};
                if (params.action){
                    const queryIndex = window.location.hash.indexOf('?')
                    const query  = window.location.hash.slice(queryIndex)
                    options.goToUrl = `app.html#/actions/${params.action}${query}`
                    console.log(options.goToUrl)
                }

                await LoginService.login(self.user.toLowerCase(), self.password, options);

                await LoadingBar.hide();
            } catch (ex) {
                await LoadingBar.hide();

                //caso o login seja negado, trata-se como um erro
                //checar se o erro é de não autorização (401)
                if (ex?.status == 401) {
                    if (ex?.data?.error) {
                        if (ex?.data?.error?.code == "LOGIN_FAILED_EMAIL_NOT_VERIFIED") {
                            //self.emailToConfirm = self.user.toLowerCase();
                            self.loginNotValidated = true;
                        } else if (ex?.data?.error?.code == "LOGIN_FAILED_CELLPHONE_NOT_VERIFIED") {
                            //self.phoneToConfirm = self.user
                            self.loginNotValidated = true;
                        } else if (ex.data.error.code == "LOGIN_FAILED") {
                            self.loginFailed = true;
                        }
                    } else {
                        dialogs.error($translate.instant("UNKNOWN_ERROR"))
                    }
                } else if (ex?.status == 400) {
                    if (ex?.data?.error?.errorCode == 48) {
                        dialogs.error('Seu usuário está bloqueado. Entre em contato com a Idha Tecnologia pelo email suporte@idha.com.br para mais informações')
                    } else if (R.includes(ex?.data?.error?.errorCode,[55,56])) {
                        dialogs.error('Foi encontrado um problema com sua situação cadastral. Entre em contato com a Idha Tecnologia pelo email suporte@idha.com.br para mais informações')
                    } else{
                        idhaApiError(ex);
                    }
                } else {
                    dialogs.error($translate.instant("UNKNOWN_ERROR"))
                }
            }
        }

    };

    this.sendVerificationToken = async function () {

        const loginInformedIsEmail = () => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return emailRegex.test(self.user);
        }

        LoadingBar.show();

        try {

            if (loginInformedIsEmail()) {
                
                await UserIdha.sendConfirmationEmail({email: self.user}).$promise
            } else {
                
                await managerApi.UserIdha.confirmPhone(self.user)
            }

            self.state = 'activate_account'

        }  catch (error) {
            dialogs.error("Falha ao solicitar ativação!")
            console.error(error)
        }
        finally {
            LoadingBar.hide();
        }

        

    }

    this.screenWidth = function (){
    if (window.screen.availWidth > 1279) {
        return "loginVersion-lg"
    }
    return "loginVersion"
}
    this.init = function () {
        var unsubscribeRedux = $ngRedux.connect(state => (
            {
                loggedUser: state.loggedUser
            }
        ))(self);


        try {
            SidebarService.closeAllSideBars();

            History.clear();

            BackButton.addEvent(() => { });

            const accessToken: string = window.localStorage.getItem('$LoopBack$accessTokenId') || null

            if (accessToken && self.loggedUser) {
                window.location.href = 'app.html#/';
                return
            }

            if ($stateParams.state && (($stateParams.state == 'register') || ($stateParams.state == 'password_reset'))) {
                this.state = $stateParams.state
            }

            if ($stateParams.email) {
                this.user = $stateParams.email.toLowerCase();
            }

            self.loginTypeList = [
                { loginType: "CONFERENTE", slug: "Conferente" },
                { loginType: "COMPRADORVENDEDOR", slug: "Comprador/Vendedor" }];
        } catch (error) {
            $window.localStorage.clear()
            throw error
        }finally{
            unsubscribeRedux();
        }


    };

    this.getVersion = function () {
        return APP_VERSION
    }

    this.init();


}]);